import script from "./TaskRecordsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskRecordsDialog.vue?vue&type=script&setup=true&lang=js"

import "./TaskRecordsDialog.vue?vue&type=style&index=0&id=99b5436a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99b5436a"]])

export default __exports__